"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _topicService = require("../services/topicService");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _InputGroupWithIcons = _interopRequireDefault(require("@insided/shared/uikit/InputGroupWithIcons"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _DeletePollModal = _interopRequireDefault(require("./DeletePollModal"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PollEditor = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(PollEditor, _PureComponent);

  var _super = _createSuper(PollEditor);

  function PollEditor() {
    var _this;

    (0, _classCallCheck2.default)(this, PollEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      showDeleteModal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUpdateOption", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(newValue, idx) {
        var _this$props, poll, onPollUpdate;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, poll = _this$props.poll, onPollUpdate = _this$props.onPollUpdate;

                if (poll.options) {
                  poll.options[idx] = newValue;
                  onPollUpdate({
                    options: _this.props.poll.options
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDeleteOption", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(index) {
        var _this$props2, poll, onPollUpdate, newList;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = _this.props, poll = _this$props2.poll, onPollUpdate = _this$props2.onPollUpdate;
                newList = poll.options;
                newList === null || newList === void 0 ? void 0 : newList.splice(index, 1);
                onPollUpdate({
                  options: newList
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSavePoll", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var _this$props3, contentType, topicId, onShowAlert, poll, onTogglePollEditor;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props3 = _this.props, contentType = _this$props3.contentType, topicId = _this$props3.topicId, onShowAlert = _this$props3.onShowAlert, poll = _this$props3.poll, onTogglePollEditor = _this$props3.onTogglePollEditor;

              _this.setState({
                isLoading: true
              });

              _context3.prev = 2;
              _context3.next = 5;
              return (0, _topicService.editPollTitle)(contentType, topicId, poll.title);

            case 5:
              _context3.t0 = poll.options;

              if (!_context3.t0) {
                _context3.next = 9;
                break;
              }

              _context3.next = 9;
              return (0, _topicService.editPollOptions)(contentType, topicId, poll.options);

            case 9:
              onTogglePollEditor(false);

              _this.setState({
                isLoading: false
              });

              onShowAlert('success', 'Poll successfully updated');
              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t1 = _context3["catch"](2);
              onShowAlert('error', "".concat(_context3.t1 === null || _context3.t1 === void 0 ? void 0 : _context3.t1.message));

            case 17:
              _this.setState({
                isLoading: false
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 14]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(PollEditor, [{
    key: "onCloseModal",
    value: function onCloseModal() {
      this.setState({
        showDeleteModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _poll$options,
          _this2 = this;

      var _this$props4 = this.props,
          onPollUpdate = _this$props4.onPollUpdate,
          poll = _this$props4.poll,
          onTogglePollEditor = _this$props4.onTogglePollEditor,
          contentType = _this$props4.contentType,
          topicId = _this$props4.topicId,
          onShowAlert = _this$props4.onShowAlert;
      var _this$state = this.state,
          showDeleteModal = _this$state.showDeleteModal,
          isLoading = _this$state.isLoading;
      var hasVote = Object.values(poll.votes || {}).some(function (value) {
        return Number(value) > 0;
      });
      var hasLessThanTwoOptions = poll.options && poll.options.length <= 2;
      return (0, _preact.h)("div", {
        className: "poll--content"
      }, (0, _preact.h)("div", null, (0, _preact.h)(_InputGroup.default, {
        id: "edit-poll-question",
        title: "Poll question:",
        type: "text",
        onChange: function onChange(e) {
          onPollUpdate({
            title: e.target.value
          });
        },
        value: poll.title,
        placeholder: "Add your question (minimum 10 characters)",
        disabled: hasVote
      }), (0, _preact.h)("p", {
        className: "poll--title"
      }, "Poll options:"), (_poll$options = poll.options) === null || _poll$options === void 0 ? void 0 : _poll$options.map(function (option, index) {
        return hasVote || hasLessThanTwoOptions ? (0, _preact.h)(_InputGroup.default, {
          key: 'option-' + index,
          id: "edit-poll-option-".concat(index + 1),
          title: "",
          type: "text",
          onChange: /*#__PURE__*/function () {
            var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(e) {
              return _regenerator.default.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return _this2.onUpdateOption(e.target.value, index);

                    case 2:
                      return _context4.abrupt("return", _context4.sent);

                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            return function (_x4) {
              return _ref4.apply(this, arguments);
            };
          }(),
          value: option,
          placeholder: "+ Insert an answer here",
          disabled: hasVote
        }) : (0, _preact.h)(_InputGroupWithIcons.default, {
          key: 'option-' + index,
          attributes: {
            type: 'text',
            value: option,
            placeholder: '+ Insert an answer here'
          },
          className: "qa-poll-option",
          postIcon: (0, _preact.h)(_assets.default, {
            onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
              return _regenerator.default.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return _this2.onDeleteOption(index);

                    case 2:
                      return _context5.abrupt("return", _context5.sent);

                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            })),
            icon: "close",
            size: 16,
            color: "#2B3346"
          }),
          onChange: /*#__PURE__*/function () {
            var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(newValue) {
              return _regenerator.default.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return _this2.onUpdateOption(newValue, index);

                    case 2:
                      return _context6.abrupt("return", _context6.sent);

                    case 3:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            }));

            return function (_x5) {
              return _ref6.apply(this, arguments);
            };
          }(),
          disabled: hasVote
        });
      }), (0, _preact.h)(_Button.default, {
        title: "Save changes",
        variant: "save",
        size: "small",
        disabled: hasVote,
        isLoading: isLoading,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
          return _regenerator.default.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt("return", _this2.onSavePoll());

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        })),
        "data-qa": "save-poll"
      }), (0, _preact.h)(_Button.default, {
        title: "Delete poll",
        variant: "danger",
        size: "small",
        onClick: function onClick() {
          return _this2.setState({
            showDeleteModal: true
          });
        },
        "data-qa": "delete-poll"
      }), (0, _preact.h)(_Button.default, {
        title: "Cancel",
        variant: "text",
        onClick: function onClick() {
          return onTogglePollEditor(false);
        }
      })), showDeleteModal && (0, _preact.h)(_DeletePollModal.default, {
        contentType: contentType,
        topicId: topicId,
        onPollUpdate: onPollUpdate,
        onTogglePollEditor: onTogglePollEditor,
        onShowAlert: onShowAlert,
        onClose: function onClose() {
          return _this2.onCloseModal();
        }
      }));
    }
  }]);
  return PollEditor;
}(_preactCompat.PureComponent);

var _default = PollEditor;
exports.default = _default;